export enum EventFieldName {
  DeviceType = 'DeviceType',
  EventGroupName = 'EventGroupName',
  EventName = 'EventName',
  Description = 'Description',
  Severity = 'Severity',
  Status = 'Status',
  Value = 'Value',
  UnitOfMeasure = 'UnitOfMeasure',
  Commodity = 'Commodity',
  DeviceUID = 'DeviceUID',
  Model = 'Model',
  CustomerName = 'CustomerName',
  CustomerNumber = 'CustomerNumber',
  Address = 'Address',
  CommDeviceId = 'CommDeviceId',
  SerialNumber = 'SerialNumber',
  AccountNumber = 'AccountNumber',
  CustomerSubNumber = 'CustomerSubNumber',
  LastDetectedUtc = 'LastDetectedUtc',
  StartedAtUtc = 'StartedAtUtc',
  EndedAtUtc = 'EndedAtUtc',
  LastDetectedUtcPeriod = 'LastDetectedUtcPeriod',
  StartedAtUtcPeriod = 'StartedAtUtcPeriod',
  EndedAtUtcPeriod = 'EndedAtUtcPeriod'
}
